// Interfaces
import {Language} from '../enums/Language'
import {Validator} from 'vee-validate'
import ptBr from 'vee-validate/dist/locale/pt_BR'
import cs from 'vee-validate/dist/locale/cs'
import de from 'vee-validate/dist/locale/de'
import en from 'vee-validate/dist/locale/en'
import es from 'vee-validate/dist/locale/es'
import fr from 'vee-validate/dist/locale/fr'
import it from 'vee-validate/dist/locale/it'
import ko from 'vee-validate/dist/locale/ko'
import nl from 'vee-validate/dist/locale/nl'
import pl from 'vee-validate/dist/locale/pl'
import ptPT from 'vee-validate/dist/locale/pt_PT'
import ro from 'vee-validate/dist/locale/ro'
import ru from 'vee-validate/dist/locale/ru'
import sk from 'vee-validate/dist/locale/sk'
import sv from 'vee-validate/dist/locale/sv'
import tr from 'vee-validate/dist/locale/tr'
import zhCn from 'vee-validate/dist/locale/zh_CN'

export class LanguageService {

    private static _instance;

    public static get instance() {
        if (!this._instance) {
            this._instance = new LanguageService()
        }
        return this._instance
    }

    private constructor() {

    }

    // Helper map for print the whole name of the language instead of the short code
    private static languageMap: Map<Language, string> = new Map([
        [Language.BR, 'Português brasileiro'],
        [Language.CS, 'Česky'],
        [Language.DE, 'Deutsch'],
        [Language.EN, 'English'],
        [Language.ES, 'Español'],
        [Language.FR, 'Français'],
        [Language.IT, 'Italiano'],
        [Language.KO, '한국의'],
        [Language.NL, 'Nederlands'],
        [Language.PL, 'Polski'],
        [Language.PT, 'Português'],
        [Language.RO, 'Românesc'],
        [Language.RU, 'Pусский'],
        [Language.SK, 'Slovenský'],
        [Language.SV, 'Svenska'],
        [Language.TR, 'Türkçe'],
        [Language.ZH, '中文'],
    ])

    public getPrettyLang(lang: Language): string {
        return LanguageService.languageMap.get(lang)!
    }

    private static languageNamesGerman: Map<Language, string> = new Map([
        [Language.AR, "Arabisch"],
        [Language.AZ, "Aserbaidschanisch"],
        [Language.BE, "Weißrussisch"],
        [Language.BG, "Bulgarisch"],
        [Language.BR, "Portugiesisch (Brasilien)"],
        [Language.BS, "Bosnisch"],
        [Language.CA, "Katalanisch"],
        [Language.CS, "Tschechisch"],
        [Language.DA, "Dänisch"],
        [Language.DE, "Deutsch"],
        [Language.EL, "Griechisch"],
        [Language.EN, "Englisch"],
        [Language.ES, "Spanisch"],
        [Language.ET, "Estnisch"],
        [Language.EU, "Baskisch"],
        [Language.FA, "Farsi"],
        [Language.FI, "Finnisch"],
        [Language.FR, "Französisch"],
        [Language.GD, "Gälisch"],
        [Language.HE, "Hebräisch"],
        [Language.HI, "Hindi"],
        [Language.HR, "Kroatisch"],
        [Language.HU, "Ungarisch"],
        [Language.HY, "Armenisch"],
        [Language.ID, "Indonesisch"],
        [Language.IS, "Isländisch"],
        [Language.IT, "Italienisch"],
        [Language.JA, "Japanisch"],
        [Language.KA, "Georgisch"],
        [Language.KK, "Kasachisch"],
        [Language.KM, "Khmer"],
        [Language.KO, "Koreanisch"],
        [Language.LT, "Litauisch"],
        [Language.LV, "Lettisch"],
        [Language.MR, "Marathi"],
        [Language.MK, "Mazedonisch"],
        [Language.MN, "Mongolisch"],
        [Language.MS, "Malaiisch"],
        [Language.MT, "Maltesisch"],
        [Language.NL, "Niederländisch"],
        [Language.NO, "Norwegisch"],
        [Language.PL, "Polnisch"],
        [Language.PT, "Portugiesisch"],
        [Language.RO, "Rumänisch"],
        [Language.RU, "Russisch"],
        [Language.SK, "Slowakisch"],
        [Language.SL, "Slowenisch"],
        [Language.SQ, "Albanisch"],
        [Language.SR, "Serbisch"],
        [Language.SV, "Schwedisch"],
        [Language.TA, "Tamil"],
        [Language.TL, "Tagalog"],
        [Language.TH, "Thai"],
        [Language.TK, "Turkmenisch"],
        [Language.TR, "Türkisch"],
        [Language.UK, "Ukrainisch"],
        [Language.UR, "Urdu"],
        [Language.UZ, "Usbekisch"],
        [Language.VI, "Vietnamesisch"],
        [Language.ZH, "Chinesisch"]
    ])

    public getGermanLanguageName(lang: Language): string {
        return LanguageService.languageNamesGerman.get(lang)!
    }

    public localizeVeeValidate(lang: Language) {
        switch (lang) {
            case Language.BR:
                Validator.localize('pr_BR', ptBr)
                return;
            case Language.CS:
                Validator.localize('cs', cs)
                return;
            case Language.DE:
                Validator.localize('de', de)
                return;
            case Language.EN:
                Validator.localize('en', en)
                return;
            case Language.ES:
                Validator.localize('es', es)
                return;
            case Language.FR:
                Validator.localize('fr', fr)
                return;
            case Language.IT:
                Validator.localize('it', it)
                return;
            case Language.KO:
                Validator.localize('ko', ko)
                return;
            case Language.NL:
                Validator.localize('nl', nl)
                return;
            case Language.PL:
                Validator.localize('pl', pl)
                return;
            case Language.PT:
                Validator.localize('pt_PT', ptPT)
                return;
            case Language.RO:
                Validator.localize('ro', ro)
                return;
            case Language.RU:
                Validator.localize('ru', ru)
                return;
            case Language.SK:
                Validator.localize('sk', sk)
                return;
            case Language.SV:
                Validator.localize('sv', sv)
                return;
            case Language.TR:
                Validator.localize('tr', tr)
                return;
            case Language.ZH:
                Validator.localize('zh_CN', zhCn)
                return;
            default:
                Validator.localize('en', en)
        }
    }
}